var map = {
	"./10/cover.camera.react.svg": 95259,
	"./12/alert.react.svg": 10071,
	"./12/arrow.right.svg": 23577,
	"./12/cross.react.svg": 90969,
	"./12/folder.svg": 47250,
	"./12/link.svg": 50542,
	"./12/lock.react.svg": 21512,
	"./12/locked.react.svg": 89775,
	"./12/mail.svg": 86119,
	"./12/mute.react.svg": 3322,
	"./12/pen-edit.react.svg": 27103,
	"./12/person.svg": 15841,
	"./12/planet.react.svg": 2955,
	"./12/plus.svg": 54590,
	"./12/refresh.react.svg": 40748,
	"./16/button.minus.react.svg": 5743,
	"./16/button.plus.react.svg": 87591,
	"./16/catalog-settings-common.svg": 60063,
	"./16/catalog-settings-data-management.svg": 40612,
	"./16/catalog-settings-integration.svg": 25654,
	"./16/catalog-settings-payment.svg": 38674,
	"./16/catalog-settings-restore.svg": 76978,
	"./16/catalog-settings-security.svg": 50478,
	"./16/catalog-settings-storage-management.svg": 73269,
	"./16/catalog.accounts.react.svg": 60268,
	"./16/catalog.archive.react.svg": 93624,
	"./16/catalog.developer.react.svg": 74800,
	"./16/catalog.documents.react.svg": 40316,
	"./16/catalog.favorites.react.svg": 55541,
	"./16/catalog.folder.react.svg": 27380,
	"./16/catalog.import.react.svg": 86687,
	"./16/catalog.old.share.react.svg": 19362,
	"./16/catalog.portfolio.react.svg": 63142,
	"./16/catalog.private.react.svg": 91907,
	"./16/catalog.projects.react.svg": 93846,
	"./16/catalog.question.react.svg": 85668,
	"./16/catalog.recent.react.svg": 84893,
	"./16/catalog.rooms.react.svg": 38194,
	"./16/catalog.settings.react.svg": 64515,
	"./16/catalog.share.small.react.svg": 99248,
	"./16/catalog.shared.react.svg": 89567,
	"./16/catalog.spam.react.svg": 44991,
	"./16/catalog.trash.react.svg": 95164,
	"./16/catalog.user.react.svg": 16253,
	"./16/catalog.user.solid.react.svg": 16874,
	"./16/circle.cross.svg": 20876,
	"./16/cross.react.svg": 77333,
	"./16/export-room-index.react.svg": 41036,
	"./16/locked.react.svg": 53387,
	"./16/mute.react.svg": 7126,
	"./16/plus.svg": 12098,
	"./16/refresh.react.svg": 49224,
	"./16/shared.link.svg": 37493,
	"./16/vertical-dots.react.svg": 92502,
	"./17/cross.react.svg": 81004,
	"./17/plus.svg": 94521,
	"./17/vertical-dots.react.svg": 76031,
	"./20/catalog-settings-common.svg": 60244,
	"./20/catalog-settings-data-management.svg": 17053,
	"./20/catalog-settings-developer.svg": 53043,
	"./20/catalog-settings-gift.svg": 82465,
	"./20/catalog-settings-import.svg": 57628,
	"./20/catalog-settings-integration.svg": 61075,
	"./20/catalog-settings-payment.svg": 49431,
	"./20/catalog-settings-restore.svg": 99563,
	"./20/catalog-settings-security.svg": 46326,
	"./20/catalog-settings-storage-management.svg": 30946,
	"./20/catalog.accounts.react.svg": 50141,
	"./20/catalog.archive.react.svg": 66007,
	"./20/catalog.documents.react.svg": 78559,
	"./20/catalog.favorites.react.svg": 80614,
	"./20/catalog.folder.react.svg": 5333,
	"./20/catalog.portfolio.react.svg": 96945,
	"./20/catalog.private.react.svg": 65220,
	"./20/catalog.recent.react.svg": 65540,
	"./20/catalog.rooms.react.svg": 80761,
	"./20/catalog.shared.react.svg": 2742,
	"./20/catalog.trash.react.svg": 7067,
	"./20/catalog.user.react.svg": 3612,
	"./24/archive.svg": 78783,
	"./24/calendar.svg": 761,
	"./24/cell.svg": 17435,
	"./24/cellCommon.svg": 49212,
	"./24/ebook.svg": 43219,
	"./24/file.svg": 38877,
	"./24/folder.svg": 83907,
	"./24/folderComplete.svg": 30518,
	"./24/folderInProgress.svg": 40275,
	"./24/form.svg": 4233,
	"./24/html.svg": 49316,
	"./24/image.svg": 40050,
	"./24/letter.svg": 63939,
	"./24/pdf.svg": 65319,
	"./24/planet.react.svg": 37842,
	"./24/shared.svg": 62776,
	"./24/slide.svg": 54918,
	"./24/slideCommon.svg": 97477,
	"./24/sound.svg": 51232,
	"./24/text.svg": 51254,
	"./24/video.svg": 69044,
	"./24/word.svg": 7819,
	"./24/wordCommon.svg": 80076,
	"./32/archive.svg": 59634,
	"./32/calendar.svg": 72742,
	"./32/cell.svg": 50944,
	"./32/cellCommon.svg": 70351,
	"./32/ebook.svg": 73538,
	"./32/file.svg": 67238,
	"./32/folder.svg": 48312,
	"./32/folderComplete.svg": 93801,
	"./32/folderInProgress.svg": 94060,
	"./32/form.svg": 51446,
	"./32/html.svg": 37163,
	"./32/image.svg": 42675,
	"./32/letter.svg": 59316,
	"./32/pdf.svg": 72522,
	"./32/room/archive.svg": 86762,
	"./32/room/custom.svg": 27177,
	"./32/room/editing.svg": 16792,
	"./32/room/form.svg": 638,
	"./32/room/public.svg": 85559,
	"./32/room/virtual-data.svg": 8942,
	"./32/slide.svg": 92643,
	"./32/slideCommon.svg": 4692,
	"./32/sound.svg": 5617,
	"./32/text.svg": 6353,
	"./32/video.svg": 58065,
	"./32/word.svg": 68972,
	"./32/wordCommon.svg": 46211,
	"./64/archive.svg": 17067,
	"./64/calendar.svg": 81309,
	"./64/cell.svg": 95719,
	"./64/cellCommon.svg": 41808,
	"./64/ebook.svg": 775,
	"./64/file.svg": 53017,
	"./64/folder.svg": 72655,
	"./64/folderComplete.svg": 46882,
	"./64/folderInProgress.svg": 56319,
	"./64/form.svg": 25685,
	"./64/html.svg": 95728,
	"./64/image.svg": 82406,
	"./64/letter.svg": 89935,
	"./64/pdf.svg": 79779,
	"./64/slide.svg": 79274,
	"./64/slideCommon.svg": 72289,
	"./64/sound.svg": 14316,
	"./64/text.svg": 90258,
	"./64/video.svg": 65776,
	"./64/word.svg": 25255,
	"./64/wordCommon.svg": 42704,
	"./96/archive.svg": 14884,
	"./96/calendar.svg": 76540,
	"./96/cell.svg": 21326,
	"./96/cellCommon.svg": 11242,
	"./96/ebook.svg": 46120,
	"./96/file.svg": 95100,
	"./96/folder.svg": 62598,
	"./96/folderComplete.svg": 78799,
	"./96/folderInProgress.svg": 21878,
	"./96/form.svg": 28396,
	"./96/html.svg": 25013,
	"./96/image.svg": 13965,
	"./96/letter.svg": 34778,
	"./96/pdf.svg": 2692,
	"./96/slide.svg": 37989,
	"./96/slideCommon.svg": 32070,
	"./96/sound.svg": 89467,
	"./96/text.svg": 97379,
	"./96/video.svg": 36807,
	"./96/word.svg": 36458,
	"./96/wordCommon.svg": 65025
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56840;